import { createContext, useContext } from 'react';
import type { ChatModel } from '../model';

const ChatWindowModelContext = createContext<ChatModel | null>(null);

export const ChatWindowModelProvider = ChatWindowModelContext.Provider;

export const useChatWindowModel = () => {
  const model = useContext(ChatWindowModelContext);
  if (!model) {
    throw new Error('ChatWindowModelProvider is missing');
  }
  return model;
};

